import type { IconProps } from '../types/IconProps.ts';
export const ImageOff: IconProps = {
    name: 'ImageOff',
    children: [
        `<path d="M21 15V5a2 2 0 0 0-2-2H9M20.32 20.5A2 2 0 0 1 19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 .5-1.32M6 21l7-7M18 12l3 3" />`,
        `<path d="M10.73 10a2 2 0 1 1-3.05-2.5M2 2l20 20" />`,
    ]
};